import usePopupScrollLock from "./usePopupScrollLock";
import { useEffect, useState } from "react";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";

const DOMAINS = ["chorki.win"];

const NOTICES = [
  {
    bn: "দৈনিক প্রথম জমাতে ২০% বোনাস",
    en: "20% bonus on the first deposit of the day",
    lines: [
      { icon: "♛", bn: "দৈনিক প্রথম আমানত বোনাস ২০%! যত বেশি জমা করবেন, তত বেশি বোনাস পাবেন", en: "20% bonus on your first deposit of the day. The more you deposit, the more bonus you receive." },
      { icon: "✦", bn: "প্রতিদিনের হট অফার পেতে এখনই টেলিগ্রাম গ্রুপে যুক্ত হোন!", en: "Join the Telegram group now for the daily hot offers!", link: true },
      { icon: "✉", bn: "টেলিগ্রাম সাপোর্ট: @chorki", en: "Telegram support: @chorki" },
    ],
  },
  {
    bn: "👑 প্রথম জমা বোনাস সর্বোচ্চ ৮৮,৮৮৮",
    en: "👑 First deposit bonus up to 88,888",
    lines: [
      { icon: "♛", bn: "প্রথম জমা বোনাস সর্বোচ্চ ৮৮,৮৮৮", en: "First deposit bonus up to 88,888" },
      { icon: "➜", bn: "রেজিস্ট্রেশন > লগইন > জমা।", en: "Register > Log in > Deposit." },
      { icon: "✓", bn: "প্রথম জমার জন্য আলাদা করে নিবন্ধনের দরকার নেই— সিস্টেম স্বয়ংক্রিয়ভাবে আপনার অ্যাকাউন্টে বোনাস প্রদান করবে।", en: "No separate registration is needed for the first deposit. The bonus is added to your account automatically." },
      { icon: "✦", bn: "প্রতিদিনের হট অফার পেতে এখনই টেলিগ্রাম গ্রুপে যুক্ত হোন!", en: "Join the Telegram group now for the daily hot offers!", link: true },
      { icon: "✉", bn: "টেলিগ্রাম সাপোর্ট: @chorki", en: "Telegram support: @chorki" },
    ],
  },
  {
    bn: "🎉 প্রতি শনিবার সুপার বোনাস দিবস!",
    en: "🎉 Super bonus day every Saturday!",
    lines: [
      { icon: "🎉", bn: "প্রতি শনিবার সুপার বোনাস দিবস! প্রিয় chorki সদস্যগণ, এখন থেকে প্রতি শনিবারকে “সুপার বোনাস দিবস” হিসেবে উদযাপন করা হবে।", en: "Super bonus day every Saturday. Dear chorki members, every Saturday is now Super Bonus Day." },
      { icon: "✓", bn: "এই বিশেষ দিনে, সিস্টেম সক্রিয় সকল প্লেয়ারের মধ্যে মোট ৮৮৮,৮৮৮,৮৮৮,৮৮৮ বোনাস বিতরণ করবে।", en: "On this day the system shares a total bonus of 888,888,888,888 among active players." },
      { icon: "🎁", bn: "লগইন করলেই আপনার ভাগ্য বদলে যেতে পারে — এক ক্লিকেই পেয়ে যেতে পারেন বিশাল বোনাস!", en: "Logging in can change your luck — one click can bring a huge bonus." },
      { icon: "▦", bn: "প্রতি শনিবার", en: "Every Saturday" },
      { icon: "💰", bn: "সৌভাগ্যের পরিমাণঃ মোট ৮৮৮,৮৮৮,৮৮৮,৮৮৮ (ধাপসম বিতরণ)", en: "Fortune pool: 888,888,888,888 in total, shared in stages" },
      { icon: "✦", bn: "প্রতিদিনের হট অফার পেতে এখনই টেলিগ্রাম গ্রুপে যুক্ত হোন!", en: "Join the Telegram group now for the daily hot offers!", link: true },
      { icon: "✉", bn: "টেলিগ্রাম সাপোর্ট: @chorki", en: "Telegram support: @chorki" },
    ],
  },
  {
    bn: "chorki অ্যাপ ডাউনলোড করুন এবং সর্বোচ্চ ৮৮,৮৮৮ টাকা বোনাস জিতে নিন! শুধু ক্লিক করে ডাউনলোড করুন।",
    en: "Download the chorki app and win up to 88,888. Just click to download.",
    lines: [
      { icon: "♛", bn: "chorki অ্যাপ ডাউনলোড করুন এবং সর্বোচ্চ ৮৮,৮৮৮ টাকা বোনাস জিতে নিন! শুধু ক্লিক করে ডাউনলোড করুন।", en: "Download the chorki app and win up to 88,888. Just click to download." },
      { icon: "✓", bn: "ইনস্টল করুন এবং লগইন করলেই পুরস্কার আপনার অ্যাকাউন্টে।", en: "Install and log in, and the reward is added to your account." },
      { icon: "✦", bn: "প্রতিদিনের হট অফার পেতে এখনই টেলিগ্রাম গ্রুপে যুক্ত হোন!", en: "Join the Telegram group now for the daily hot offers!", link: true },
      { icon: "✉", bn: "টেলিগ্রাম সাপোর্ট: @chorki", en: "Telegram support: @chorki" },
    ],
  },
  {
    bn: "Welcome to chorki!",
    en: "Welcome to chorki!",
    lines: [
      { icon: "♠", bn: "chorki-এ স্বাগতম! আমাদের অনলাইন ক্যাসিনোর জমকালো উদ্বোধনের ঘোষণা দিতে পেরে আমরা অত্যন্ত আনন্দিত। সম্মানিত সদস্যদের জন্য রয়েছে বিশেষ ডিপোজিট বোনাস, অ্যাপ ডাউনলোড বোনাস এবং নতুন সদস্যদের রেজিস্ট্রেশন বোনাস। এই বোনাসগুলো পাওয়ার সুযোগ সীমাহীন, আর এখনই আপনি সেগুলো গ্রহণ করতে পারেন।", en: "Welcome to chorki. We are glad to announce the opening of our online casino. Members can claim a deposit bonus, an app download bonus, and a new-member registration bonus, and those offers can be claimed now." },
    ],
  },
];

export default function ReferenceAnnounce({ onClose, covered = false }) {
  usePopupScrollLock();
  const lang = useContextSelector(AuthContext, (ctx) => ctx.lang);
  const [selected, setSelected] = useState(0);
  const english = lang === "en";

  useEffect(() => {
    const onKey = (event) => {
      if (event.key === "Escape" && !covered) onClose?.();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose, covered]);

  const notice = NOTICES[selected];

  return (
    <div className="ref-announce-overlay" aria-hidden={covered || undefined} inert={covered}>
      <div className="ref-announce" role="dialog" aria-modal={!covered} aria-labelledby="ref-announce-title">
        <h2 id="ref-announce-title" className="ref-announce-title">chorki</h2>
        <img className="ref-announce-logo" src="/assets/chorki/logo.svg" alt="" />
        <button type="button" className="ref-announce-close" onClick={() => onClose?.()} aria-label="Close">×</button>
        <div className="ref-announce-body" tabIndex={0} aria-label="Announcement content">
          <ul className="ref-announce-nav">
            {NOTICES.map((item, index) => (
              <li key={item.bn}>
                <button type="button" className={index === selected ? "active" : undefined} onClick={() => setSelected(index)}>
                  <span>{english ? item.en : item.bn}</span>
                  <span aria-hidden="true">›</span>
                </button>
              </li>
            ))}
          </ul>
          <div className="ref-announce-detail">
            {notice.lines.map((line) => (
              <p className="ref-announce-line" key={line.bn}>
                <i aria-hidden="true">{line.icon}</i>
                {line.link ? (
                  <a href="https://t.me/" target="_blank" rel="noreferrer">{english ? line.en : line.bn}</a>
                ) : (
                  <span>{english ? line.en : line.bn}</span>
                )}
              </p>
            ))}
            <p className="ref-announce-domains">
              {DOMAINS.map((domain) => <span key={domain}>{domain}</span>)}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
